import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fdeaf24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fields" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Fra dato", -1))
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Til dato", -1))
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Kategorier", -1))
const _hoisted_8 = { class: "exclude-weborders" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ekskluder webordre", -1))
const _hoisted_11 = { class: "submit" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hent data", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
    class: "category-form"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "date",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.date_from) = $event))
        }, null, 512), [
          [_vModelText, _ctx.form.date_from]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "date",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.date_to) = $event))
        }, null, 512), [
          [_vModelText, _ctx.form.date_to]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_CategorySelect, {
          modelValue: _ctx.form.categories,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.categories) = $event)),
          categories: _ctx.categories
        }, null, 8, ["modelValue", "categories"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.exclude_web_orders) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.form.exclude_web_orders]
          ]),
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Button, {
          type: "submit",
          color: "green",
          class: "submit__button"
        }, {
          default: _withCtx(() => [
            (_ctx.form.processing)
              ? (_openBlock(), _createBlock(_component_SvgIcon, {
                  key: 0,
                  class: "loading-icon",
                  type: "mdi",
                  path: _ctx.icons.loading
                }, null, 8, ["path"]))
              : _createCommentVNode("", true),
            _hoisted_12
          ]),
          _: 1
        })
      ])
    ])
  ], 32))
}